import { render, staticRenderFns } from "./moblie.vue?vue&type=template&id=5670791a&scoped=true&"
import script from "./moblie.vue?vue&type=script&lang=js&"
export * from "./moblie.vue?vue&type=script&lang=js&"
import style0 from "./moblie.vue?vue&type=style&index=0&id=5670791a&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5670791a",
  null
  
)

export default component.exports